import classNames from 'classnames'
import { useState } from 'react'

import type { ReactElement } from 'react'

import CreateFromFileForm from './CreateFromFileForm'
import GenerateWithMlForm from './GenerateWithMlForm'

import FileIcon from '~/assets/file-icon.png'
import CatalogMediaCard from '~/components/CatalogMediaCard'
import AddToModal from '~/components/CatalogModal'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'

import './styles.scss'

export interface ICard {
  categories: string[]
  coloringTemplateId: string
  mediaUrl?: string
  pdfFileId: string
  previewPngFileId: string
  prompt?: string
  templateOrigin: string
}

const CreateTemplate = (): ReactElement => {
  /** Local state */

  useDocumentTitle('Catalog - Create Template')

  const [cards, setCards] = useState<ICard[]>([])

  const [isAddToModalOpen, setIsAddToModalOpen] = useState(false)

  const [selectedModal, setSelectedModal] = useState<'category' | 'daily'>('category')

  const [selectedTemplate, setSelectedTemplate] = useState('')

  /** Handlers */

  const addToCards = (newPost: ICard) => setCards((prev) => [...prev, newPost])

  const handleOpenAddToModal = (templateId: string, type: 'daily' | 'category') => {
    setIsAddToModalOpen(true)
    setSelectedModal(type)
    setSelectedTemplate(templateId)
  }

  const handleCloseAddToModal = () => setIsAddToModalOpen(false)

  /** Render */

  return (
    <div className="catalog-create-template-view">
      <ViewTitle>Create Template</ViewTitle>
      <div className="view-content">
        <div className="generators">
          <div className="generator create-from-file">
            <span className="generator__title">Create from PDF</span>
            <CreateFromFileForm addToCards={addToCards} />
          </div>
          <span className="separator">
            <span className="separator__caption">Or</span>
          </span>
          <div className="generator generate-with-ml">
            <span className="generator__title">Generate with ML</span>
            <GenerateWithMlForm addToCards={addToCards} />
          </div>
        </div>
        <div className={classNames('cards-section', { 'cards-section--empty': cards.length === 0 })}>
          {cards.length > 0 ? (
            <div className="cards-section__cards">
              {cards.map(({ categories, coloringTemplateId, mediaUrl, prompt, templateOrigin }, idx) => (
                <CatalogMediaCard
                  categories={categories || []}
                  coloringTemplateId={coloringTemplateId}
                  disabled={false}
                  key={idx}
                  mediaUrl={mediaUrl || FileIcon}
                  onOpenAddToCategoryModal={() => handleOpenAddToModal(coloringTemplateId, 'category')}
                  onOpenAddToDailyModal={() => handleOpenAddToModal(coloringTemplateId, 'daily')}
                  prompt={prompt}
                  templateOrigin={templateOrigin}
                />
              ))}
            </div>
          ) : (
            <span className="cards-section__empty-caption">Generated posts will appear here 😎</span>
          )}
        </div>
      </div>
      <AddToModal
        isOpen={isAddToModalOpen}
        onClose={handleCloseAddToModal}
        selectedTemplate={selectedTemplate}
        type={selectedModal}
      />
    </div>
  )
}

export default CreateTemplate
